import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  authorResolver,
  authorFollowerResolver,
  authorGenderResolver,
  authorGeoHighGenealogyResolver,
  authorGeoHighResolver,
  authorGeoInfosResolver,
  authorHandleResolver,
  authorIdResolver,
  authorKarmaResolver,
  authorLinkResolver,
  authorLocationResolver,
  authorNameResolver,
  authorUrlResolver,
  authorVerifiedResolver,
  avatarUrlResolver,
  defaultAvatarUrlResolver
} from './author'

const streamDataFieldResolvers: FieldResolver[] = [
  authorResolver,
  authorFollowerResolver,
  authorGenderResolver,
  authorGeoHighGenealogyResolver,
  authorGeoHighResolver,
  authorGeoInfosResolver,
  authorHandleResolver,
  authorIdResolver,
  authorKarmaResolver,
  authorLinkResolver,
  authorLocationResolver,
  authorNameResolver,
  authorUrlResolver,
  authorVerifiedResolver,
  avatarUrlResolver,
  defaultAvatarUrlResolver
]

const authorRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default authorRelatedFieldsResolver
